/**
 * @file increaseId
 * @author Cuttle Cong
 * @date 2018/2/13
 * @description
 */

let id = 1

export default function get() {
  return id++
}
